.undoBtn {
  position: absolute;
  top: 8px;
  right: 44px;
  z-index: 4;
  cursor: pointer;
}

.redoBtn {
  position: absolute;
  top: 8px;
  right: 24px;
  z-index: 4;
  cursor: pointer;
}

.relativeDiv {
  position: relative;
}

.addDiv {
  width: 25%;
  height: 8px;
  transition: height 1s ease-in-out;
  cursor: pointer;
  position: relative;
  background-color: #9cf0a318;
}

.addIcon {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  transform: translate(-4px, -8px);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out;
  background-color: #9cf0a34b;
  padding: 2px;
  border-radius: 4px;
}

.addDiv:hover > .addIcon {
  opacity: 1;
  visibility: visible;
}

.addIcon:hover {
  color: #07440c;
}

.removeLineIcon,
.removeIcon {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out;
  background-color: #ee19194b;
  padding: 2px;
  border-radius: 4px;
}

.removeIcon {
  transform: translate(-4px, 12px);
}

.removeLineIcon {
  transform: translate(48px, -4px);
}

div:hover > span > .removeIcon,
div:hover > span > .removeLineIcon {
  opacity: 1;
  visibility: visible;
}

.removeLineIcon:hover,
.removeIcon:hover {
  color: #ee1919;
}
